const copy = (text: string, textarea: HTMLTextAreaElement) => {
  try {
    textarea.setAttribute('readonly', 'true')
    textarea.setAttribute('contenteditable', 'true')
    // prevent scroll from jumping to the bottom when focus is set
    textarea.style.position = 'fixed'
    textarea.style.top = '0'
    textarea.style.left = '0'
    textarea.style.zIndex = '-1'
    textarea.style.height = '0'
    textarea.style.opacity = '0.01'
    textarea.style.overflow = 'hidden'
    textarea.style.pointerEvents = 'none'
    textarea.style.clipPath = 'polygon(0 0, 0 0, 0 0, 0 0)'
    textarea.style.fontSize = '0'
    // used to preserve spaces and line breaks
    textarea.style.whiteSpace = 'pre'
    // do not inherit user-select (it may be `none`)
    // @ts-ignore
    textarea.style.webkitUserSelect = 'text'(
      textarea.style as any
    ).msUserSelect = 'text'
    textarea.style.userSelect = 'text'

    // prevent keyboard blink
    // textarea.style.visibility = 'hidden'

    textarea.value = text

    document.body.appendChild(textarea)

    textarea.focus()
    textarea.select()

    const range = document.createRange()
    range.selectNodeContents(textarea)

    const selection = window.getSelection()
    if (selection) {
      selection.removeAllRanges()
      selection.addRange(range)
    }

    textarea.setSelectionRange(0, textarea.value.length)
    const result = document.execCommand('copy')
    document.body.removeChild(textarea)
    return result
  } catch (error) {
    console.error(error)
  } finally {
    document.body.removeChild(textarea)
  }
}

export const copyToClipboard = (text: string) => {
  try {
    if (navigator.clipboard) {
      return navigator.clipboard.writeText(text)
    } else {
      return copy(text, document.createElement('textarea'))
    }
  } catch (error) {
    console.error('Something went wrong to add link to clipboard', error)
  }
}
